import RequestManager from "./RequestManager.js";
global.RequestManager = new RequestManager();
